import React from 'react';
import PropTypes from 'prop-types';

function HowItWorksItem({ image, title, description }) {
  return (
    <div className="mn_item">
      <div className="mn_imageWrap">
        <img src={image} alt="" />
      </div>
      <h3 className="mn_itemTitle">{title}</h3>
      <p className="mn_itemDescription">{description}</p>
    </div>
  );
}

HowItWorksItem.propTypes = {
  image: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.node,
};

HowItWorksItem.defaultProps = {
  image: '',
  title: '',
  description: '',
};

export default HowItWorksItem;
